import { CausalAssetAnalysisListResponse, CausalAssetAnalysisListRequest, DwModelListResponse, DwModelListRequest } from "../type/causal-asset";

export const adaptCausalAssetAnalysisListRequest = (
  request: CausalAssetAnalysisListRequest
): string => {
  const params = new URLSearchParams();
  
  if (request.page !== undefined) {
    params.append('page', request.page.toString());
  }
  
  if (request.items_per_page !== undefined) {
    params.append('items_per_page', request.items_per_page.toString());
  }
  
  if (request.is_core_model !== undefined) {
    params.append('is_core_model', request.is_core_model.toString());
  }
  
  return params.toString();
};

export const adaptCausalAssetAnalysisListResponse = (
  response: any
): CausalAssetAnalysisListResponse => {
  return {
    analyses: response.analyses || [],
    page: response.page || 1,
    items_per_page: response.items_per_page || 1000,
    total_count: response.total_count || 0,
  };
};

export const adaptDwModelListRequest = (
  request: DwModelListRequest
): string => {
  const params = new URLSearchParams();
  
  if (request.page !== undefined) {
    params.append('page', request.page.toString());
  }
  
  if (request.items_per_page !== undefined) {
    params.append('items_per_page', request.items_per_page.toString());
  }
  
  if (request.is_fixed !== undefined) {
    params.append('is_fixed', request.is_fixed.toString());
  }
  
  if (request.is_core_model !== undefined) {
    params.append('is_core_model', request.is_core_model.toString());
  }
  
  return params.toString();
};

export const adaptDwModelListResponse = (
  response: any
): DwModelListResponse => {
  return {
    dwmodels: response.dwmodels || [],
    page: response.page || 1,
    items_per_page: response.items_per_page || 1000,
    total_count: response.total_count || 0,
  };
};